export const NameSuggestionFormat = 'json';
export const MaxSuggestions = 6;
